import React from "react";
import { Query } from "react-admin";
import moment from "moment";
import { isNil, head } from "ramda";
import styled from "styled-components";

const BlackListDiv = styled.div({
  paddingTop: "10px",
  paddingBottom: "10px",
  color: "red",
  fontSize: "18px",
  textDecoration: "underline"
});

class CheckBlackList extends React.Component {
  checkEntriesIfAnyActive = entries => {
    if (isNil(entries)) {
      return [];
    }
    return (
      entries.map(item => {
        if (moment(item.date).isBefore(moment()) && isNil(item.date_end)) {
          return item;
        }
      }) || []
    );
  };
 
  render() {
    const payload = {
      pagination: { page: 1, perPage: 1000 },
      filter: { client_id: this.props.record.client_id },
      sort: { field: "id", order: "ASC" }
    };
    return (
      <Query type="GET_LIST" resource="black_lists" payload={payload}>
        {({ data, loading, error }) => {
          if (error) {
            return <p>ERROR</p>;
          }
          const iemBlackList = head(this.checkEntriesIfAnyActive(data));
          return (
            <BlackListDiv>
              {!isNil(iemBlackList)
                ? `Attention, this client is on blacklist since ${moment(
                  iemBlackList.date
                ).format("YYYY-MM-DD")} - ${iemBlackList.reason}`
                : ""}
            </BlackListDiv>
          );
        }}
      </Query>
    );
  }
}

export default CheckBlackList;



// WEBPACK FOOTER //
// ./src/components/checkBlackList.js